export const calculateDropPositionToTargetElement = (e: DragEvent) => {
    const target = e.currentTarget as Element;
    const rect = target.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const elementLeft = rect.left + scrollLeft;
    const elementTop = rect.top + scrollTop;

    // Style props
    return {
        top: e.pageY - elementTop,
        left: e.pageX - elementLeft
    };
};
